import { FC, memo, ReactNode } from 'react'

import { WinnersAnnouncementHeaderIcon } from '@components/atoms/assets/WinnersAnnouncementHeaderIcon'

export interface IWinnersAnnouncementHeaderProps {
  children: ReactNode
}

const WinnersAnnouncementHeaderComponent: FC<
  IWinnersAnnouncementHeaderProps
> = ({ children }) => {
  return (
    <div className="flex">
      <div className="flex items-center bg-dark/40 rounded-r-[2.8125rem]">
        <div className="p-3">
          <WinnersAnnouncementHeaderIcon />
        </div>
        <div className="pr-20 text-sm">{children}</div>
      </div>
    </div>
  )
}

export const WinnersAnnouncementHeader = memo(
  WinnersAnnouncementHeaderComponent
)
